import { render, staticRenderFns } from "./ProductPrice.vue?vue&type=template&id=5fbce58b&scoped=true"
import script from "./ProductPrice.vue?vue&type=script&lang=js"
export * from "./ProductPrice.vue?vue&type=script&lang=js"
import style0 from "./ProductPrice.vue?vue&type=style&index=0&id=5fbce58b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fbce58b",
  null
  
)

export default component.exports